<template>
  <div class="material-check-page frame-page file-transfer-page">
    <div class="page-intro">
      <p>
        将文件编码为彩色动画码，在屏幕上播放；对方用摄像头扫描即可接收（无需网络）。
        适合隔离内网等气隙场景：本机发送，手机 / 另一台电脑扫描接收。
      </p>
    </div>

    <section class="panel transfer-panel">
      <div class="panel-title panel-title-actions">
        <div class="panel-title-left">
          <span class="step">1</span>
          <span>彩色码发送</span>
          <span class="tag tag-done">屏幕播码</span>
        </div>
        <div class="panel-title-right">
          <Button size="s" @click="reloadFrame">重新加载</Button>
          <Button size="s" color="primary" @click="openFullscreen">全屏发送</Button>
          <Button size="s" @click="downloadOffline">下载离线页</Button>
        </div>
      </div>

      <div class="encoder-wrap">
        <iframe
          :key="reloadKey"
          class="encoder-frame"
          :src="frameSrc"
          title="彩色码文件发送"
          allow="fullscreen; autoplay"
        />
      </div>

      <ol class="transfer-tips">
        <li>点击画面中「选择文件」，选中要传输的文件后开始播放动画码。</li>
        <li>建议点「全屏发送」，并提高屏幕亮度；对方用摄像头持续对准本屏。</li>
        <li>侧栏可选模式：给电脑摄像头扫手机屏时优先用 <strong>Bu</strong>，帧率可降到 5～10。</li>
        <li>可将「离线页」拷到手机，在外网设备上直接打开发送（无需联网）。</li>
      </ol>
    </section>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { message } from 'heyui';
import '@/views/material-check/material-check.less';

const reloadKey = ref(0);
const frameSrc = computed(() => `/cimbar/index.html?t=${reloadKey.value}`);

function reloadFrame() {
  reloadKey.value += 1;
}

function openFullscreen() {
  window.open('/cimbar/index.html', '_blank', 'noopener,noreferrer');
}

function downloadOffline() {
  const a = document.createElement('a');
  a.href = '/cimbar/offline-send.html';
  a.download = '彩色码离线发送页.html';
  a.click();
  message.success('已开始下载离线发送页');
}
</script>

<style lang="less" scoped>
.file-transfer-page {
  max-width: 1100px;
}

.transfer-panel {
  padding-bottom: 16px;
}

.encoder-wrap {
  border: 1px solid #e8ecf1;
  border-radius: 10px;
  overflow: hidden;
  background: #111;
  height: min(70vh, 700px);
}

.encoder-frame {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  background: #000;
}

.transfer-tips {
  margin: 16px 0 0;
  padding-left: 20px;
  color: #6b7280;
  font-size: 13px;
  line-height: 1.8;
}
</style>
